module.exports = __webpack_public_path__ + "img/tab_location-w.11d0646f.svg";